import { Shield, Clock, Users, Briefcase } from "lucide-react";
import { Link } from "react-router-dom";

export function TrustSection() {
  const items = [
    { icon: Shield, title: "No Auto-Spam", desc: "Every job is manually reviewed for relevance. Quality over quantity." },
    { icon: Clock, title: "48-Hour Delivery", desc: "Get your complete application kit within 48 hours." },
    { icon: Users, title: "You Stay in Control", desc: "We prepare everything, you decide which jobs to apply to." },
  ];

  return (
    <section className="border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-8 text-center">
          {items.map((item) => (
            <div key={item.title} className="p-6">
              <item.icon className="w-10 h-10 text-[#002FA7] mx-auto mb-4" />
              <h3 className="font-semibold text-zinc-900 mb-2">{item.title}</h3>
              <p className="text-zinc-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="bg-zinc-900 text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Briefcase className="w-5 h-5 text-[#002FA7]" />
            <span className="font-bold">GetJobInterviews.com</span>
          </div>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/terms" className="text-zinc-400 hover:text-white transition-colors">
              Terms & Privacy
            </Link>
            <Link to="/contact" className="text-zinc-400 hover:text-white transition-colors">
              Contact Us
            </Link>
          </div>
          <p className="text-sm text-zinc-400">
            &copy; {new Date().getFullYear()} GetJobInterviews. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
